import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

/* Depth via box-shadow only (never background-image/-color) so callers that override
   the background with their own status/role color classes (very common in this app)
   keep working exactly as before through twMerge's last-wins resolution. */
const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 shadow-[0_1px_0_0_rgba(255,255,255,0.5)_inset,0_1px_2px_-1px_rgba(15,23,42,0.25)]",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
